// extracted by mini-css-extract-plugin
module.exports = {"tagCloud":"antd-pro-pages-dashboard-analysis-components-charts-tag-cloud-index-tagCloud"};